import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { fetchFaqsNotesDocuments,fetchServiceRequestFaqsNotesDocuments, saveFaqsNotesDocuments, updateFaqsNotesDocuments, deleteFaqsNotesDocuments } from '../../store/actions/faqsNotesDocuments';
import { selectNotes } from '../../store/selectors/faqsNotesDocuments';
import { selectAuthenticatedUser } from '../../store/selectors/auth';
import Notes from '../../components/Notes';
import { setSearch, clearSearch } from '../../store/actions/search';
import { selectPRLoader } from '../../store/selectors/PropertyLoader';
import Loader from '../../components/Loader';

class ServiceRequestNotes extends Component {

  constructor(props) {
    super(props);
  }

  state = {
   loading:false
  };

  componentDidMount() {
    this.props.clearSearch()
  }

  onSaveNote = note => {
    const {  onSaveFaqsNotesDocuments, onUpdateFaqsNotesDocuments  } = this.props;

  
    let utcTime = ''
    if(note.appointment){
      let date = new Date(note.appointment.date);
    let time = new Date(note.appointment.time)
    let hours = time.getHours();
    let minutes =time.getMinutes();
    date.setHours(hours);
    date.setMinutes(minutes)
 
    //  utcTime = date.toUTCString()
    utcTime = date
    }
    

    if(note && note.id){
      let data = {
        ItemId: this.props.serviceRequest.id,
        "id": note.id,
        Name: 'NOTES',
        Type: 'NOTES',
        ItemType: 'Service Request',        
        "data": JSON.stringify(note).toString(),
        "UserId": this.props.user.id,
        // "ReminderDate":utcTime,
        "TicketNumber":this.props.serviceRequest.ticketNumber.toString(),
        'visibilityType':note.visibilityType,
        noteVisibleToHomeownerOccupantRealtor:note.noteVisibleToHomeownerOccupantRealtor,
      }
      if(note.appointment){
        data.ReminderDate = utcTime
      }
      onUpdateFaqsNotesDocuments(data)
    } else {
      note = { ...note,'author':{
        "id": this.props.user.id,
        "firstName": this.props.user.firstname,
        "lastName": this.props.user.lastname
      },'createdAt': new Date()}

      let data = {
        ItemId: this.props.serviceRequest.id,
        Name: 'NOTES',
        Type: 'NOTES',
        ItemType: 'Service Request',
        Data: JSON.stringify(note).toString(),
        UserId: this.props.user.id,
        // "ReminderDate":utcTime,
        "TicketNumber":this.props.serviceRequest.ticketNumber.toString(),
        'visibilityType':note.visibilityType,
        noteVisibleToHomeownerOccupantRealtor:note.noteVisibleToHomeownerOccupantRealtor,


      }

      if(note.appointment){
        data.ReminderDate = utcTime
      }

      
     onSaveFaqsNotesDocuments(data)
    }
  }

  render() {
    const { notes, serviceRequest, onDeleteFaqsNotesDocuments, setSearch, loader } = this.props;
    return (
      this.state.loading ? <Loader /> :
      <Notes
        from={'serviceRequests'}
        breadcrumb={serviceRequest.number}
        notes={notes}
        onSaveNote={this.onSaveNote}
        onDeleteNote={ notes => onDeleteFaqsNotesDocuments({...notes,Type:'NOTES'})}
        onSearch={e => setSearch({ notes: e.target.value.trim() })}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  notes: selectNotes(state),
  user: selectAuthenticatedUser(state),
  loader: selectPRLoader(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  // onFetchFaqsNotesDocumentss: fetchFaqsNotesDocuments,
  onFetchFaqsNotesDocumentss: fetchServiceRequestFaqsNotesDocuments,
  onSaveFaqsNotesDocuments: saveFaqsNotesDocuments,
  onUpdateFaqsNotesDocuments: updateFaqsNotesDocuments,
  onDeleteFaqsNotesDocuments: deleteFaqsNotesDocuments,
  setSearch,
  clearSearch
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ServiceRequestNotes);
